/** ERROR TAGS to send to Sentry.io */
/** Tags for Errors to send to sentry.io */
class ErrorTagUtil {
}
// Bundle Errors
ErrorTagUtil.commonMutationObserver = 'CommonMutationObserver';
ErrorTagUtil.eventBus = 'HekateEventBus';
ErrorTagUtil.heartbeat = 'HeartbeatError';
ErrorTagUtil.utmDupe = 'DuplicateUtmParameter';
ErrorTagUtil.personalizationError = 'PersonalizationError';
ErrorTagUtil.searchError = 'FreeTextSearchError';
ErrorTagUtil.ptcDebugClientError = 'PtcDebugClientError';
export default ErrorTagUtil;
